import { comment, forum, post } from '@/api'
import {
	FORUM_CATEGORIES_ERROR,
	FORUM_CATEGORIES_GET,

	FORUM_GET,

	FORUM_COMMENTS_GET,
	FORUM_CHOSE_CATEGORY,
	FORUM_CHOSE_CATEGORY_DELETE,

	FORUM_LOADING_STATUS,
	FORUMS_GET,

	FORUM_POST_ADD_STATUS,
	FORUM_POST_ADD,
	FORUM_POST_ADD_ERROR,

	FORUM_COMMENT_ADD_STATUS,
	FORUM_COMMENT_ADD,
	FORUM_COMMENT_ADD_ERROR
} from '@/store/forum/types'

const fetchForumCategories = async (ctx, filters) => {
	ctx.commit(FORUM_LOADING_STATUS, true)
	try {
		const { data, headers } = await forum.fetchForumCategories(filters)
		const pageCount = headers['x-pagination-page-count']
		const response = { data, pageCount }
		ctx.commit(FORUM_CATEGORIES_GET, response)
		ctx.commit(FORUM_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(FORUM_CATEGORIES_ERROR, e)
		ctx.commit(FORUM_LOADING_STATUS, false)

		console.error(e)
	}
}

const fetchForums = async (ctx, query) => {
	ctx.commit(FORUM_LOADING_STATUS, true)
	try {
		const { data, headers } = await forum.fetchForums(query)
		const pageCount = headers['x-pagination-page-count']
		const response = { data, pageCount }
		ctx.commit(FORUMS_GET, response)
		ctx.commit(FORUM_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(FORUM_CATEGORIES_ERROR, e)
		ctx.commit(FORUM_LOADING_STATUS, false)

		console.error(e)
	}
}

const getForum = async (ctx, forumId) => {
	ctx.commit(FORUM_LOADING_STATUS, true)
	try {
		const { data: forumData } = await forum.getForum(forumId)
		const { data: forumCommentData } = await forum.getForumComments(forumId)

		ctx.commit(FORUM_GET, forumData)
		ctx.commit(FORUM_COMMENTS_GET, forumCommentData)

		ctx.commit(FORUM_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(FORUM_CATEGORIES_ERROR, e)
		ctx.commit(FORUM_LOADING_STATUS, false)

		console.error(e)
	}
}

const addComment = async (ctx, commentData) => {
	ctx.commit(FORUM_COMMENT_ADD_STATUS, true)
	try {
		const { data } = await comment.addComment(commentData)

		ctx.commit(FORUM_COMMENT_ADD_STATUS, false)
		ctx.commit(FORUM_COMMENT_ADD, data)
	} catch (e) {
		ctx.commit(FORUM_COMMENT_ADD_ERROR, e)
		throw e
	}
}

const addPost = async (ctx, postData) => {
	ctx.commit(FORUM_POST_ADD_STATUS, true)
	try {
		const { data } = await forum.addPost(postData)

		ctx.commit(FORUM_POST_ADD_STATUS, false)
		ctx.commit(FORUM_POST_ADD, data)
	} catch (e) {
		ctx.commit(FORUM_POST_ADD_ERROR, e)
		throw e
	}
}

const chosenCategory = async (ctx, categoryId) => {
	try {
		ctx.commit(FORUM_CHOSE_CATEGORY, categoryId)
	} catch (e) {
		throw e
	}
}

const deleteChosenCategory = async (ctx) => {
	try {
		ctx.commit(FORUM_CHOSE_CATEGORY_DELETE)
	} catch (e) {
		throw e
	}
}
export default {
	fetchForumCategories,
	fetchForums,
	getForum,
	addComment,
	chosenCategory,
	deleteChosenCategory,
	addPost
}


